"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardHeader = _interopRequireDefault(require("UIComponents/card/UICardHeader"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UIRibbon = _interopRequireDefault(require("UIComponents/ribbon/UIRibbon"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UIMultiColumnSection = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnSection"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _default = _react.default.createClass({
  displayName: "DynoEditorDemoEmail",
  propTypes: {
    kickbackEmails: _react.default.PropTypes.array.isRequired,
    currentIndex: _react.default.PropTypes.number.isRequired,
    kickbackPreviews: _react.default.PropTypes.array
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowEditorPreview.leadFlowDemoEmail." + suffix;
  },
  createMarkup: function createMarkup(markup) {
    return {
      __html: markup
    };
  },
  render: function render() {
    var _this$props = this.props,
        currentIndex = _this$props.currentIndex,
        kickbackEmails = _this$props.kickbackEmails,
        kickbackPreviews = _this$props.kickbackPreviews;
    var preview = kickbackPreviews[currentIndex] || {};
    var mailCount = kickbackEmails.length;
    var subject = preview.subject;
    var from = preview.fromName;
    var body = preview.emailBodyHtml;
    var sender = preview.replyTo;

    var to = _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('receiver')
    });

    return _react.default.createElement("div", {
      className: "dyno-editor-demo-email"
    }, _react.default.createElement("div", {
      className: "dyno-editor-demo-email-card-wrapper"
    }, _react.default.createElement(_UICardWrapper.default, {
      className: "dyno-editor-demo-email-ui-card-wrapper"
    }, _react.default.createElement(_UIRibbon.default, {
      className: "dyno-editor-demo-email-ribbon",
      use: "thunderdome"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('ribbonText'),
      options: {
        count: currentIndex + 1,
        max: mailCount
      }
    })), _react.default.createElement("div", {
      className: "dyno-editor-demo-email-scroll-wrapper"
    }, _react.default.createElement(_UICardHeader.default, {
      className: "dyno-editor-demo-email-header",
      title: subject,
      titleSize: "large"
    }), _react.default.createElement(_UICardSection.default, {
      className: "dyno-editor-demo-card-section"
    }, _react.default.createElement(_UIMultiColumn.default, {
      flush: true,
      className: "dyno-editor-demo-multicolumn"
    }, _react.default.createElement(_UIMultiColumnSection.default, {
      className: "dyno-editor-demo-card-multicolumn-section"
    }, _react.default.createElement(_UIMultiColumnGroup.default, {
      className: "dyno-editor-demo-sender-receiver"
    }, _react.default.createElement(_UIMultiColumnItem.default, {
      className: "dyno-editor-demo-email-column-left"
    }, _react.default.createElement(_UIAvatar.default, {
      lookup: {
        type: 'email',
        primaryIdentifier: sender
      },
      size: "md"
    })), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement("div", {
      className: "dyno-editor-demo-email-column-right"
    }, from, _react.default.createElement("br", null), to))), _react.default.createElement(_UIMultiColumnGroup.default, {
      className: "dyno-editor-demo-email-content"
    }, _react.default.createElement(_UIMultiColumnItem.default, {
      className: "dyno-editor-demo-email-column-left"
    }), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement("div", {
      className: "dyno-editor-demo-email-column-right-content"
    }, _react.default.createElement("div", {
      className: "dyno-editor-demo-email-body",
      dangerouslySetInnerHTML: this.createMarkup(body)
    })))))))))));
  }
});

exports.default = _default;
module.exports = exports.default;